// The date the calendar is showing, short enough for a phone toolbar.
//
// "08/23/2026 - 08/29/2026" ran off the row, clipping the picker icon and
// pushing Filters onto its own line. Only the week view needs shortening, and
// it must still say which week it is — including when the week straddles a
// month or a year, where dropping the repeat would read as nonsense.

import { format, startOfWeek, endOfWeek } from 'date-fns';

export type RangeView = 'list' | 'day' | 'week' | 'month';

const EN_DASH = '–';

/** A short label for the current date or range. */
export function compactRangeLabel(date: Date, view: RangeView): string {
  if (view === 'month') return format(date, 'MMM yyyy');
  if (view !== 'week') return format(date, 'EEE, MMM d');

  const start = startOfWeek(date, { weekStartsOn: 0 });
  const end = endOfWeek(date, { weekStartsOn: 0 });

  // Spelling the year out only when the week crosses one keeps the common
  // case short without ever leaving the reader to guess.
  if (start.getFullYear() !== end.getFullYear()) {
    return `${format(start, 'MMM d, yyyy')} ${EN_DASH} ${format(end, 'MMM d, yyyy')}`;
  }
  if (start.getMonth() !== end.getMonth()) {
    return `${format(start, 'MMM d')} ${EN_DASH} ${format(end, 'MMM d')}`;
  }
  return `${format(start, 'MMM d')} ${EN_DASH} ${format(end, 'd')}`;
}
